import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * The Telegram Bot API baseline the backend capability registry was audited
 * against. Fetched once and cached for the tab — never hardcoded in the UI, so
 * a registry bump shows up everywhere without touching components.
 */
let cache = null;
let inflight = null;

export function useApiVersion() {
  const [summary, setSummary] = useState(cache);
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      // /health is public, so the login screen can render the version too.
      inflight = api
        .get("/health")
        .then((r) => {
          cache = r.data.telegram;
          return cache;
        })
        .catch(() => null)
        .finally(() => {
          inflight = null;
        });
    }
    let alive = true;
    inflight.then((s) => {
      if (alive && s) setSummary(s);
    });
    return () => {
      alive = false;
    };
  }, []);
  return summary;
}

/** "v10.3", or an empty string until the version is known. */
export function useApiVersionLabel() {
  const summary = useApiVersion();
  return summary?.api_version ? `v${summary.api_version}` : "";
}
